(function () {
  'use strict';

  class PdpBundle {
    constructor(el) {

      this.el        = el;
      this.blockId   = el.dataset.blockId;
      this.variantId = el.dataset.variantId;
      this.promoType = el.dataset.promoType;
      this.discount   = parseInt(el.dataset.discount, 10) || 0;
      this.discountT3 = parseInt(el.dataset.discountT3, 10) || this.discount;
      this.applyTo   = el.dataset.applyTo || 'all';
      this.maxQty    = parseInt(el.dataset.maxQty, 10) || 2;
      this.basePrice = parseInt(el.dataset.basePrice, 10) || 0;
      this.is3Tier   = el.dataset.steps === '2+3';
      this.modal     = document.getElementById('pdp-bundle-modal-' + this.blockId);
      this.atcBtn    = document.getElementById('pdp-bundle-atc-' + this.blockId);

      // Cache repeated DOM lookups
      this.shopPayEl      = null; // shop-pay form removed from bundle liquid
      this.tierEls        = el.querySelectorAll('.pdp-bundle__tier');
      this.atcLabelEl     = this.atcBtn ? (this.atcBtn.querySelector('span') || this.atcBtn) : null;
      this.tier1PriceEl   = el.querySelector('.pdp-bundle__tier[data-tier="1"] .pdp-bundle__price');
      this.tier2PriceEl   = el.querySelector('.pdp-bundle__tier[data-tier="2"] .pdp-bundle__price');
      this.tier2CompareEl = el.querySelector('.pdp-bundle__tier[data-tier="2"] .pdp-bundle__price-compare');
      this.tier2SavingsEl = el.querySelector('.pdp-bundle__tier[data-tier="2"] .pdp-bundle__tier-savings');
      this.tier3PriceEl   = el.querySelector('.pdp-bundle__tier[data-tier="3"] .pdp-bundle__price');
      this.tier3CompareEl = el.querySelector('.pdp-bundle__tier[data-tier="3"] .pdp-bundle__price-compare');
      this.tier3SavingsEl = el.querySelector('.pdp-bundle__tier[data-tier="3"] .pdp-bundle__tier-savings');
      this.modalBody      = this.modal ? this.modal.querySelector('.pdp-bundle__modal-body') : null;
      this.productsTpl    = document.getElementById('pdp-bundle-products-' + this.blockId);
      this.slotCurrentImg = el.querySelector('.pdp-bundle__slot-current img');
      this._modalStamped  = false;

      // id → price lookup (parsed once)
      const rawPrices  = el.dataset.variantPrices;
      this.variantPriceMap = rawPrices ? Object.fromEntries(
        JSON.parse(rawPrices).map((v) => [String(v.id), v.price])
      ) : {};

      this.currentSlot = null;
      this.slots       = {};

      const checkedRadio = el.querySelector('.pdp-bundle__radio:checked');
      this.selectedTier  = checkedRadio ? parseInt(checkedRadio.value, 10) : 1;

      this.variantSelects = document.querySelector('variant-selects, variant-radios');
      this._bindEvents();
      this._updateAtcState();
      // _initCustomSelects deferred — runs on first modal open
    }

    _bindEvents() {
      // Single delegated handler on root element — covers tier headers, slots, ATC
      this.el.addEventListener('click', (e) => {
        // Tier header click
        const tierEl = e.target.closest('.pdp-bundle__tier');
        if (tierEl && !e.target.closest('.pdp-bundle__slot-empty, .pdp-bundle__slot-filled, .pdp-bundle__slot-change, .pdp-bundle__slot-remove')) {
          const radio = tierEl.querySelector('.pdp-bundle__radio');
          if (radio && !radio.checked) {
            radio.checked = true;
            this._selectTier(parseInt(radio.value, 10));
          }
          return;
        }

        const addBtn = e.target.closest('.pdp-bundle__slot-empty');
        if (addBtn) {
          e.stopPropagation();
          const slotEl = addBtn.closest('.pdp-bundle__slot');
          if (!slotEl) return;
          const tier = parseInt(slotEl.dataset.tier, 10);
          if (tier !== this.selectedTier) {
            const radio = this.el.querySelector(`.pdp-bundle__radio[value="${tier}"]`);
            if (radio) { radio.checked = true; this._selectTier(tier); }
          }
          this._openModal(slotEl.dataset.slot);
          return;
        }

        const changeBtn = e.target.closest('.pdp-bundle__slot-change');
        if (changeBtn) {
          e.stopPropagation();
          this._openModal(changeBtn.dataset.slot);
          return;
        }

        const removeBtn = e.target.closest('.pdp-bundle__slot-remove');
        if (removeBtn) {
          e.stopPropagation();
          this._removeSlot(removeBtn.dataset.slot);
        }
      });

      // Tier radio changes
      this.el.querySelectorAll('.pdp-bundle__radio').forEach((radio) => {
        radio.addEventListener('change', () => this._selectTier(parseInt(radio.value, 10)));
      });

      // Keep variantId + price + slot image in sync when PDP variant selector changes
      if (this.variantSelects) {
        this.variantSelects.addEventListener('change', () => {
          const variant = this.variantSelects.currentVariant;
          if (!variant) return;

          // Update variantId + basePrice
          this.variantId = String(variant.id);
          const mapped = this.variantPriceMap[this.variantId];
          if (mapped != null) this.basePrice = mapped;
          this._updateTierPrices();
          this._updateAtcState();

          // Update slot-current image
          if (this.slotCurrentImg) {
            let src = variant.featured_image?.src;
            if (!src && variant.option1) {
              const match = this.variantSelects.getVariantData()
                .find(v => v.option1 === variant.option1 && v.featured_image?.src);
              src = match?.featured_image?.src;
            }
            if (src) {
              const sized = src.includes('?') ? src + '&width=100' : src + '?width=100';
              this.slotCurrentImg.src           = sized;
              this.slotCurrentImg.srcset        = '';
              this.slotCurrentImg.style.width   = '30px';
              this.slotCurrentImg.style.aspectRatio = '2/3';
              this.slotCurrentImg.style.height  = 'auto';
            }
          }
        });
      }

      if (!this.modal) return;

      // Modal close buttons (delegated)
      this.modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-close-modal]')) { this._closeModal(); return; }
        const btn = e.target.closest('.pdp-bundle__choose-btn');
        if (btn) this._chooseProduct(btn.closest('.pdp-bundle__product-row'));
      });

      this.modal.addEventListener('change', (e) => {
        const row = e.target.closest('.pdp-bundle__product-row');
        if (row) this._updateRowAvailability(row);
      });

      // ATC
      if (this.atcBtn) this.atcBtn.addEventListener('click', () => this._addToCart());
    }

    _openModal(slotKey) {
      this.currentSlot = slotKey;
      if (this.modal) {
        // Stamp template content into modal body on first open
        if (!this._modalStamped && this.productsTpl && this.modalBody) {
          this.modalBody.appendChild(this.productsTpl.content.cloneNode(true));
          this._modalStamped = true;
          this._initCustomSelects();
          this.modal.querySelectorAll('.pdp-bundle__product-row')
            .forEach((row) => this._updateRowAvailability(row));
        }

        this.modal.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.classList.add('pdp-bundle-modal-open');

        // Attach escape + outside-click listeners only while modal is open
        this._onKeyDown = (e) => { if (e.key === 'Escape') this._closeModal(); };
        this._onDocClick = () => {
          this.modal.querySelectorAll('.pdp-bundle__custom-select.is-open')
            .forEach((s) => s.classList.remove('is-open'));
        };
        document.addEventListener('keydown', this._onKeyDown);
        document.addEventListener('click', this._onDocClick);
      }
    }

    _closeModal() {
      if (this.modal) {
        this.modal.setAttribute('hidden', '');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.classList.remove('pdp-bundle-modal-open');

        document.removeEventListener('keydown', this._onKeyDown);
        document.removeEventListener('click', this._onDocClick);
        this._onKeyDown = this._onDocClick = null;
      }
      this.currentSlot = null;
    }

    _selectTier(tier) {
      this.selectedTier = tier;
      this.tierEls.forEach((tierEl) => {
        tierEl.classList.toggle('pdp-bundle__tier--active', parseInt(tierEl.dataset.tier, 10) === tier);
      });
      this._updateAtcState();
    }

    _updateRowAvailability(row) {
      if (!row._variants) row._variants = JSON.parse(row.dataset.variants || '[]');
      const selected = [];
      row.querySelectorAll('.pdp-bundle__product-option').forEach((optEl, i) => {
        const availableValues = row._variants
          .filter((v) => v.available && selected.every((opt, j) => v['option' + (j + 1)] === opt))
          .map((v) => v['option' + (i + 1)]);
        optEl.querySelectorAll('input, option').forEach((el) => { el.disabled = !availableValues.includes(el.value); });
        optEl.querySelector('select')?._syncCustom?.();
        selected.push(optEl.querySelector(':checked')?.value);
      });
      const match = row._variants.find((v) => selected.every((opt, i) => v['option' + (i + 1)] === opt));
      row.querySelector('.pdp-bundle__choose-btn').disabled = !match?.available;
    }

    _chooseProduct(row) {
      if (!this.currentSlot || !row) return;

      // Cache parsed variants on the element to avoid re-parsing on change
      if (!row._variants) row._variants = JSON.parse(row.dataset.variants || '[]');
      const variants     = row._variants;
      const productTitle = row.dataset.productTitle;
      const productImage = row.dataset.productImage;
      const productPrice = parseInt(row.dataset.productPrice, 10);

      let variantId    = variants[0]?.id ?? null;
      let price        = variants[0]?.price ?? productPrice;
      const image      = productImage;
      let optionLabels = [];

      const optionEls = row.querySelectorAll('.pdp-bundle__product-option');
      if (optionEls.length && variants.length) {
        const selected = [];
        optionEls.forEach((optEl) => {
          const radio = optEl.querySelector('.pdp-bundle__color-swatch-input:checked');
          selected.push(radio ? radio.value : (optEl.querySelector('.pdp-bundle__size-select')?.value ?? null));
        });
        optionLabels = selected.filter(Boolean);
        const match = variants.find((v) =>
          selected.every((opt, i) => v['option' + (i + 1)] === opt)
        );
        if (!match?.available) return;
        if (match) {
          variantId = match.id;
          price     = match.price;
        }
      }

      this.slots[this.currentSlot] = { variantId, title: productTitle, image, price, options: optionLabels };
      this._renderSlot(this.currentSlot);
      this._closeModal();
      this._updateAtcState();
      this._updateTierPrices();
    }

    _renderSlot(slotKey) {
      const data = this.slots[slotKey];
      if (!data) return;
      const tier   = slotKey.split('-')[0];
      const slotEl = this.el.querySelector(`.pdp-bundle__slot[data-slot="${slotKey}"]`);
      if (!slotEl) return;
      const optionsHtml = data.options?.length
        ? `<span class="pdp-bundle__slot-options ctm-subbody">${data.options.join(' / ')}</span>`
        : '';
      slotEl.innerHTML = `
        <div class="pdp-bundle__slot-filled">
          <img class="pdp-bundle__slot-img" src="${data.image}" alt="${data.title}" loading="lazy">
          <div class="pdp-bundle__slot-meta">
            <span class="pdp-bundle__slot-name ctm-subbody">${data.title}</span>
            ${optionsHtml}
          </div>
          <button type="button" class="pdp-bundle__slot-change ctm-subbody" data-slot="${slotKey}" data-tier="${tier}" aria-label="Change selection">Change</button>
          <button type="button" class="pdp-bundle__slot-remove" data-slot="${slotKey}" aria-label="Remove selection">&times;</button>
        </div>`;
    }

    _removeSlot(slotKey) {
      delete this.slots[slotKey];
      const slotNum = slotKey.split('-')[1];
      const slotEl  = this.el.querySelector(`.pdp-bundle__slot[data-slot="${slotKey}"]`);
      if (!slotEl) return;
      slotEl.innerHTML = `
        <button type="button" class="pdp-bundle__slot-empty" aria-label="Choose a product for slot ${slotNum}">
          <span class="pdp-bundle__slot-icon" aria-hidden="true">+</span>
          <span class="pdp-bundle__slot-label button button-tertiary">Add</span>
        </button>`;
      this._updateAtcState();
      this._updateTierPrices();
    }

    // Returns how many extra slots the given tier requires
    _requiredSlots(tier) {
      if (tier === 1) return 0;
      if (this.is3Tier) return tier - 1; // tier 2 → 1, tier 3 → 2
      return this.maxQty - 1;            // existing: 2-item → 1, 3-item → 2
    }

    _updateAtcState() {
      if (this.selectedTier === 1) {
        document.body.classList.remove('bundle-tier-2-active');
      } else {
        document.body.classList.add('bundle-tier-2-active');

        if (!this.atcBtn) return;
        if (this.variantSelects && this.variantSelects.currentVariant && !this.variantSelects.currentVariant.available) {
          this.atcBtn.disabled = true; return;
        }
        const required = this._requiredSlots(this.selectedTier);
        for (let i = 1; i <= required; i++) {
          if (!this.slots[`${this.selectedTier}-${i}`]) { this.atcBtn.disabled = true; return; }
        }
        this.atcBtn.disabled = false;
      }
    }

    async _addToCart() {
      const tier  = this.selectedTier;
      const items = [
        {
          id: parseInt(this.variantId, 10),
          quantity: 1,
        },
      ];

      if (tier > 1) {
        const required = this._requiredSlots(tier);
        for (let i = 1; i <= required; i++) {
          const key = `${tier}-${i}`;
          const s   = this.slots[key];
          if (s?.variantId) {
            items.push({
              id: parseInt(s.variantId, 10),
              quantity: 1,
            });
          }
        }
      }

      const labelEl = this.atcLabelEl;
      const root    = window.Shopify?.routes?.root ?? '/';

      this.atcBtn.disabled = true;
      labelEl.textContent  = 'Adding...';

      try {
        const resp = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!resp.ok) {
          const err = await resp.json().catch(() => ({}));
          throw new Error(err.description || 'Cart add failed');
        }

        // Notify cart subscribers — Rebuy detects this and opens its drawer.
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-bundle' });

        labelEl.textContent = 'Added!';
      } catch (e) {
        console.error('[pdp-bundle] ATC error:', e);
        labelEl.textContent = 'Error — try again';
      } finally {
        setTimeout(() => {
          labelEl.textContent = 'Add to Cart';
          this._updateAtcState();
        }, 2000);
      }
    }

    _updateTierPrices() {
      const mainPrice = this.basePrice;
      if (!mainPrice) return;

      const discFactor = 100 - this.discount;

      // Tier 1 — no discount
      if (this.tier1PriceEl) this.tier1PriceEl.textContent = this._formatMoney(mainPrice);

      // Tier 2
      if (this.tier2PriceEl) {
        const slot1Price = this.slots['2-1']?.price ?? mainPrice;
        let t2Full, t2Price;

        if (this.is3Tier) {
          // In 3-tier mode tier 2 is always 2 items
          t2Full  = mainPrice + slot1Price;
          t2Price = (this.promoType === 'bogo' || this.applyTo === '1')
            ? mainPrice + Math.floor(slot1Price * discFactor / 100)
            : Math.floor(t2Full * discFactor / 100);
        } else if (this.maxQty >= 3) {
          const slot2Price = this.slots['2-2']?.price ?? mainPrice;
          t2Full = mainPrice + slot1Price + slot2Price;
          if (this.applyTo === '1') {
            const cheapest = Math.min(mainPrice, slot1Price, slot2Price);
            t2Price = t2Full - cheapest + Math.floor(cheapest * discFactor / 100);
          } else if (this.applyTo === '2') {
            const sorted = [mainPrice, slot1Price, slot2Price].sort((a, b) => a - b);
            t2Price = sorted[2] + Math.floor((sorted[0] + sorted[1]) * discFactor / 100);
          } else {
            t2Price = Math.floor(t2Full * discFactor / 100);
          }
        } else {
          t2Full  = mainPrice + slot1Price;
          t2Price = (this.promoType === 'bogo' || this.applyTo === '1')
            ? mainPrice + Math.floor(slot1Price * discFactor / 100)
            : Math.floor(t2Full * discFactor / 100);
        }

        const t2Savings = t2Full - t2Price;
        this.tier2PriceEl.textContent = this._formatMoney(t2Price);
        if (this.tier2CompareEl) this.tier2CompareEl.textContent = this._formatMoney(t2Full);
        if (this.tier2SavingsEl && this.promoType !== 'bogo') {
          // Show dollar savings only when all required slots for tier 2 are filled
          let allT2Filled;
          if (this.is3Tier) {
            allT2Filled = !!this.slots['2-1'];            // 2+3 mode: 1 extra slot
          } else if (this.maxQty >= 3) {
            allT2Filled = !!(this.slots['2-1'] && this.slots['2-2']); // steps=3: 2 extra slots
          } else {
            allT2Filled = true;                           // steps=2: 1 slot, always real
          }
          this.tier2SavingsEl.textContent = allT2Filled
            ? `You save ${this._formatMoney(t2Savings)}`
            : `You save ${this.discount}%`;
        }
      }

      // Tier 3 (3-tier mode only) — uses separate discountT3
      if (this.is3Tier && this.tier3PriceEl) {
        const discFactorT3 = 100 - this.discountT3;
        const slot1Price = this.slots['3-1']?.price ?? mainPrice;
        const slot2Price = this.slots['3-2']?.price ?? mainPrice;
        const t3Full     = mainPrice + slot1Price + slot2Price;
        const t3Price    = Math.floor(t3Full * discFactorT3 / 100);
        const t3Savings  = t3Full - t3Price;

        this.tier3PriceEl.textContent = this._formatMoney(t3Price);
        if (this.tier3CompareEl) this.tier3CompareEl.textContent = this._formatMoney(t3Full);
        if (this.tier3SavingsEl) {
          // Show dollar savings only when both extra slots are filled
          const allT3Filled = this.slots['3-1'] && this.slots['3-2'];
          this.tier3SavingsEl.textContent = allT3Filled
            ? `You save ${this._formatMoney(t3Savings)}`
            : `You save ${this.discountT3}%`;
        }
      }
    }

    _formatMoney(cents) {
      return window.Shopify?.formatMoney?.(cents) || `$${(cents / 100).toFixed(2)}`;
    }

    _initCustomSelects() {
      if (!this.modal) return;
      this.modal.querySelectorAll('.pdp-bundle__size-select').forEach((select) => {
        this._createCustomSelect(select);
      });
    }

    _createCustomSelect(select) {
      const wrapper   = document.createElement('div');
      wrapper.className = 'pdp-bundle__custom-select';

      const trigger   = document.createElement('button');
      trigger.type    = 'button';
      trigger.className = 'pdp-bundle__custom-select-trigger';

      const valueSpan = document.createElement('span');
      valueSpan.className = 'pdp-bundle__custom-select-value';
      valueSpan.textContent = select.options[select.selectedIndex]?.text ?? '';

      const chevron = document.createElement('span');
      chevron.className = 'pdp-bundle__custom-select-chevron';
      chevron.innerHTML = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      trigger.append(valueSpan, chevron);

      const dropdown = document.createElement('ul');
      dropdown.className = 'pdp-bundle__custom-select-dropdown';
      dropdown.setAttribute('role', 'listbox');

      Array.from(select.options).forEach((opt, i) => {
        const li = document.createElement('li');
        li.className     = 'pdp-bundle__custom-select-option';
        li.setAttribute('role', 'option');
        li.dataset.value = opt.value;
        li.textContent   = opt.text;
        if (i === select.selectedIndex) li.classList.add('is-selected');
        dropdown.appendChild(li);
      });

      wrapper.append(trigger, dropdown);
      select.style.display = 'none';
      select.before(wrapper);

      select._syncCustom = () => {
        Array.from(dropdown.children).forEach((li, i) => li.classList.toggle('is-disabled', select.options[i].disabled));
      };

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = wrapper.classList.contains('is-open');
        this.modal.querySelectorAll('.pdp-bundle__custom-select.is-open')
          .forEach((s) => s.classList.remove('is-open'));
        if (!isOpen) wrapper.classList.add('is-open');
      });

      dropdown.addEventListener('click', (e) => {
        const option = e.target.closest('.pdp-bundle__custom-select-option');
        if (!option || option.classList.contains('is-disabled')) return;
        select.value = option.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        valueSpan.textContent = option.textContent;
        dropdown.querySelectorAll('.pdp-bundle__custom-select-option')
          .forEach((o) => o.classList.remove('is-selected'));
        option.classList.add('is-selected');
        wrapper.classList.remove('is-open');
      });
    }
  }

  function init() {
    document.querySelectorAll('.pdp-bundle[data-block-id]').forEach((el) => {
      if (!el._pdpBundle) el._pdpBundle = new PdpBundle(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
